import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

export const updateFormAnswer = createAsyncThunk(
  "locationShow/updateFormAnswer",
  async ({ archive, expiredAt }: any, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { data: documentCreated } = await axiosInstance.post(`${api.baseURL}document`, {
        archive: archive.id,
        title: archive.filename,
      });
      const { data: formAnswerUpdated } = await axiosInstance.patch(
        `${api.baseURL}formanswer/${state.locationShow.formAnswerSelected.id}`,
        {
          document: documentCreated.id,
          expiredAt: new Date(expiredAt).getTime(),
        }
      );
      return formAnswerUpdated;
    } catch (error:any) {
      const {message} = error
      rejectWithValue(message);
      throw message;
    }
  }
);
